export function removeDash(stringValue: any) {
  return stringValue.split("-").join("");
}
